export default __webpack_public_path__ + "static/media/USAworldwideTravelExpatriates.32037cca.jpg";